export const EMAIL_ADDRESS_PATTERN_REGEX =
  "^[a-zA-Z0-9][a-zA-Z0-9.!#$%&'*\\+\\=?^_`\\{\\|\\}\\~\\-\\/]*" +
  "@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?" +
  "(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)+$"
